import { request } from '../core/request';

interface LogoutData {
  code: string;
}

const REDIRECT_URI = import.meta.env.VITE_APP_REDIRECT_URI;

// TODO 等待後端
export default async (data: LogoutData) => {
  return request('/logout', {
    method: 'POST',
    baseURL: 'common',
    data: {
      code: data.code,
      redirectUri: REDIRECT_URI,
    },
  })
    .then(() => true)
    .catch(() => false);
};
